/**
 * MetricDisplay - Shared Component
 * 
 * Displays metrics (scores, ranks, numbers) with consistent styling.
 * Used across PvP, Pokédex, and other sections.
 * 
 * Design System: Supporting Metrics - Secondary Emphasis
 */

import React from 'react';

const MetricDisplay = ({
  label,
  value,
  variant = 'default', // 'default' | 'large' | 'small'
  align = 'left', // 'left' | 'center' | 'right'
  showLabel = true,
  language = 'th',
  className = ''
}) => {
  const sizeClasses = {
    small: {
      label: 'text-xs',
      value: 'text-sm'
    },
    default: {
      label: 'text-xs',
      value: 'text-base'
    },
    large: {
      label: 'text-sm',
      value: 'text-lg'
    }
  };

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const sizes = sizeClasses[variant];
  const alignClass = alignClasses[align];

  return (
    <div className={`${alignClass} ${className}`}>
      {showLabel && label && (
        <div className={`${sizes.label} text-gray-500 mb-0.5`}>
          {label}
        </div>
      )}
      <div className={`${sizes.value} font-semibold text-gray-700`}>
        {value}
      </div>
    </div>
  );
};

export default MetricDisplay;
